import React from 'react';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { format } from 'date-fns';
import { FieldTable } from '../../../components/FieldTable/FieldTable';
import { FieldTableColumnProps } from 'components/FieldTable/FieldTableTypes';
import { PanelAvailability } from 'generated/graphql';
import {PanelPostInstructionsSelect} from "../../../components/MaterialSelects/PosterInstructions";
import {PanelAvailabilityStatusIdSelect} from "../../../components/MaterialSelects/PanelAvailabilityStatusSelect";
import {PanelPackSelect} from "../../../components/MaterialSelects/PanelPackSelect";
import {PanelBookingRestrictionIdSelect} from "../../../components/MaterialSelects/PanelBookingRestrictionSelect";


const PAColumns:FieldTableColumnProps<PanelAvailability>[] = [
  {
      header:'From',
      accessor:'first_week',
      dataType:'date',
      options: {
        date: {
            mondayOnly:true
        }
      }
  },
  {
      header:'To',
      accessor:'last_week',
      dataType:'date',
      options: {
        date: {
            sundayOnly:true
        }
      }
  },
  {
      header:'Status',
      accessor:'availability',
      dataType:'select',
      options: {
        getValue:({field})=>field.value,
        renderEditor:({field}) => <PanelAvailabilityStatusIdSelect {...field} autoFocus={true} />
    }
  },
  {
      header:'Reason',
      accessor:'reason',
      dataType:'text'
  }
];

const newPARow = function() {
return {
    first_week:'',
    last_week:'',
    availability:'Live',
    reason:''
};
};

const PanelAvailabilities = (props) => {
    console.log('PANELAVAIL RENDER');
    return(
        <div className="subtable-holder">
            <FieldTable columns={PAColumns}
            newRow={newPARow}
            readOnly={props.readOnly}
            setValue={props.setValue}
            values={props.values||[]}
            newRowLabel="Add Panel Availability"
            name={props.name}
        />
        </div>);
};

PanelAvailabilities.propTypes = {
    name: PropTypes.string,
    values: PropTypes.array,
    setValue: PropTypes.func
};

const newPRow = function() { 
    return {
    panel:'',
    code:'',
    postInstruction:{id:'',label:''},
    status:'',
    pack:null,
    number_of_slots:0,
    posters_per_slot:0,
    panelAvailabilities:[]
    };
};
const columns = [
    {
        accessor:'expand',
        dataType:'expander'
    },
    {
        header: 'Status',
        accessor: 'currentAvailability',
        dataType:'default',
        options: {
            getValue:({rowProps}) => rowProps.currentAvailability
        }
    },{
        header: 'Panel',
        accessor: 'panel',
        dataType:'text'
    },{
        header: 'Poster Instructions',
        accessor: 'postInstruction',
        dataType:'select',
        options: {
            label:'label',
            renderEditor: ({ field }) => <PanelPostInstructionsSelect {...field} allowBlank={true}/>,
        }
    },
    {
        header: 'Pack',
        accessor: 'pack',
        dataType:'select',
        options: {
            label:'label',
            renderEditor: ({ field }) => <PanelPackSelect {...field} allowBlank={true} />,
        }
    },
    {
        header: 'Restriction',
        accessor: 'restriction',
        dataType:'select',
        options: {
            getValue:({field})=> {
                const options = {
                    panel_only: 'Panel Only',
                    slot_only: 'Slot Only',
                    unbookable: 'Unbookable'
                };
                if (options[field.value]) return options[field.value];
                return 'None';
            },
            renderEditor: ({ field }) => (<PanelBookingRestrictionIdSelect {...field} autoFocus={true} />)
        }
    },
    {
        header: 'Bookable Slots',
        accessor: 'number_of_slots',
        dataType:'number',
    }, {
        header: 'Posters Per slot',
        accessor: 'posters_per_slot',
        dataType:'number'
    }, {
        header: 'Notes',
        accessor: 'notes',
        dataType:'text'
    }
    /*,{
        header:'Poster Layout Rows',
        accessor:'poster_layout_rows',
        editor: ({field}) => (<NumberInput {...field} autoFocus={true}/>),
        className:'column-date'
    },{
        header:'Poster Layout Cols',
        accessor:'poster_layout_cols',
        editor: ({field}) => (<NumberInput {...field} autoFocus={true}/>),
        className:'column-date'
    }*/
];


const PanelPane = (props) => {
    //const addPanel = useCallback((push) => () => {
        //push({ id: Date() });
    //},[]);
    //console.log('panels are',props.panels);

    const getCurrentAvailability = useCallback(({data})=>{
        if(!data?.panelAvailabilities) { return 'none'; }
        var today = format(new Date(),'yyyy-MM-dd');
        var state = 'none';
        console.log('render PanelAvailabilies for ',data);
        data?.panelAvailabilities.forEach((row)=>{
            if(state!='none' && !row.first_week) {
                return;
            }
            if(row.first_week<=today && (row.last_week=='0000-00-00'||row.last_week==''||!row.last_week||row.last_week>=today)) {
                state = row.availability;
            }
        });
        return {currentAvailability:state};
    },[]);


    return <FieldTable name="panels" values={props.panels} newRow={newPRow} columns={columns}
    getRowProps={getCurrentAvailability} setValue={props.setValue}
    loading={props.loading} className="site-panels"
    defaultSort={[{name:"panel",asc:true}]}
    readOnly={props.readOnly}
    newRowLabel="Add Panel">
        {
                        ({name, row}) => {
                            console.log('PA row is',name,row);
//                            return <div>TIS IS FAKE!!!</div>;
                            return <PanelAvailabilities readOnly={props.readOnly} setValue={props.setValue} name={name+'.panelAvailabilities'} values={row.panelAvailabilities}/>;
                        }
                    }
        </FieldTable>;
/*
    return (<FieldArray name="panels">
        {({ push }) =>
            <FieldTable columns={columns} fields={props.panels} name="panels"
                footer={<Button icon="plus" onClick={addPanel(push)}>Add Panel</Button>}
            >
            </FieldTable>

        }
    </FieldArray>);*/
}

PanelPane.propTypes = {
    panels: PropTypes.array,
    setValue: PropTypes.func
};

export default PanelPane; 